import { Model } from 'survey-core';
import { SELF_SERVE_VALUE } from '../components/questionTypes/MuiAdditionalProducts';

export const getPurchaseInfo = (survey: Model, transactionId: string) => {
  const getProductValue = (productId: string, variableName: string) =>
    survey.runExpression(`expandChoicesByUrl('${productId}', '${variableName}')`);

  const calculateDiscount = (productId: string) => {
    const price = getProductValue(productId, 'price');
    const discountedPrice = survey.runExpression(`getPriceWithDiscount('${productId}')`);
    return Number((price - discountedPrice).toFixed(2));
  };

  const { subscription, additionalProduct, discountCode } = survey.data;
  const items = [];
  const joiningFeeId = survey.runExpression("getJoiningFee('id')");
  const tax = Number(
    (
      survey.getVariable('subscriptionTotalPrice').replace(/[^\d.]/g, '') -
      survey.getVariable('totalWithDiscountAmount')
    ).toFixed(2)
  );

  if (joiningFeeId) {
    items.push({
      item_id: joiningFeeId,
      item_name: getProductValue(joiningFeeId, 'subscriptionTier'),
      discount: calculateDiscount(joiningFeeId),
      price: survey.runExpression(`getPriceWithDiscount('${joiningFeeId}')`),
      quantity: 1
    });
  }
  if (subscription) {
    items.push({
      item_id: subscription,
      item_name: getProductValue(subscription, 'subscriptionTier'),
      discount: calculateDiscount(subscription),
      price: survey.runExpression(`getPriceWithDiscount('${subscription}')`),
      quantity: 1
    });
  }
  if (additionalProduct && additionalProduct !== SELF_SERVE_VALUE) {
    items.push({
      item_id: additionalProduct,
      item_name: getProductValue(additionalProduct, 'purchaseType'),
      discount: calculateDiscount(additionalProduct),
      price: survey.runExpression(`getPriceWithDiscount('${additionalProduct}')`),
      quantity: 1
    });
  }

  return {
    event: 'purchase',
    ecommerce: {
      purchase_type: 'new',
      nrw_status: 'New',
      transaction_id: transactionId,
      value: survey.getVariable('totalWithDiscountAmount'),
      tax,
      shipping: 0,
      currency: getProductValue(subscription, 'currencyIso'),
      coupon: survey.getVariable('discount') ? discountCode : undefined,
      items
    }
  };
};
